import { AiFillExclamationCircle } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'

import Button from '../common/Button/Button.tsx'

const DisplayMessage = ({
  message,
  navigateUrl,
  navigateLabel = 'Przejdź'
}: {
  message: string
  navigateUrl?: string
  navigateLabel?: string
}) => {
  const navigate = useNavigate()

  const onPressHandle = () => {
    if (navigateUrl)
      navigateUrl.includes('http')
        ? window.open(navigateUrl, '_blank')
        : navigate(navigateUrl)
  }

  return (
    <div
      className={
        'flex flex-row mb-4 rounded transition items-center gap-4 p-4 border bg-red-50 border-red-400 text-red-800 dark:bg-opacity-25 dark:bg-red-900 dark:border-red-400 dark:text-red-200'
      }
    >
      <AiFillExclamationCircle size={28} className={'text-red-700'} />
      <div>{message}</div>
      {navigateUrl && (
        <Button
          onClick={onPressHandle}
          type={'button'}
          color={'danger'}
          variant="filled"
          size="small"
          className="ml-auto"
        >
          {navigateLabel}
        </Button>
      )}
    </div>
  )
}

export default DisplayMessage
